/* Opens the version-comparison modal from the hero link. Closes on the ×, on a
   click outside the box, and on Escape. */
window.lvModalInit = function (modalId) {
  var modal = document.getElementById(modalId);
  if (!modal || modal.dataset.lvInit) return;
  modal.dataset.lvInit = '1';

  function open() {
    modal.classList.add('is-open');
    document.body.classList.add('lv-modal-open');
    var x = modal.querySelector('[data-lv-modal-close]');
    if (x) x.focus();
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('lv-modal-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lv-modal-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-lv-modal-close]')) { close(); return; }
    if (e.target === modal) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
};
